import React, { useContext } from 'react';
import { TxTimeContext } from './TTWrapper';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import { calculateMinutes } from './utils/calculateMinutes';
import { formatExtensionMessage } from './utils/formatExtensionMessage.ts';
import { AreaRow } from './AreaRow';

function TTOutputs() {
  const {
    selectedAreas,
    setSelectedAreas,
    setMessage,
    isFirstTreatment,
    setIsFirstTreatment,
  } = useContext(TxTimeContext);

  const { minutes, extensionsTimes, extensionsTimesTotal } = calculateMinutes(
    selectedAreas,
    isFirstTreatment
  );

  const deleteArea = (area) => {
    setSelectedAreas((prevSelectedAreas) =>
      prevSelectedAreas.filter((elem) => elem.id !== area.id)
    );
    setMessage(null);
  };

  const clearAllAreas = () => {
    setSelectedAreas([]);
  };

  return (
    <section className='row justify-content-center pb-5 pt-4'>
      <div className='col-md-9 col-lg-8 col-xl-7 col-xxl-6'>
        <div className='h-100'>
          <Card className={`tt-card card-border`}>
            <div
              className={`output text-center pt-4 milan-bg-light-tur rounded-top`}
            >
              <h2 className='milan-text-primary d-h text-uppercase mb-2'>
                Treatment Time
              </h2>
              <p className='milan-text-navy text-center mb-0'>
                Schedule the appointment for
              </p>
              <Card.Body className='py-2'>
                <h3 className='text-center milan-text-tur display-6 mb-3 lh-1'>
                  {selectedAreas.length > 0 ? (
                    <div className='mt-2'>
                      <span>{minutes}</span>
                      <span className='fs-3 fw-500 d-block'>Minutes</span>
                    </div>
                  ) : (
                    <span>_ _ _</span>
                  )}
                </h3>
                {selectedAreas.length > 0 && (
                  <div className='custom-checkbox d-flex justify-content-center mb-2'>
                    <label htmlFor='first-treatment' className='ps-4'>
                      <input
                        type='checkbox'
                        value={isFirstTreatment}
                        name='first-treatment'
                        id='first-treatment'
                        onChange={() => setIsFirstTreatment(!isFirstTreatment)}
                      />
                      <span className='checkmark'></span>First Treatment
                    </label>
                  </div>
                )}
              </Card.Body>
            </div>
            <Card.Body id='tt-items' className='p-0 rounded-bottom'>
              <Table striped bordered className='mb-0'>
                {selectedAreas.length > 0 && (
                  <thead>
                    <tr className='text-xs'>
                      <th className='fw-500'>Area</th>
                      <th className='fw-500'>Pain Management</th>
                      <th className='fw-500'>Larger Surface Area</th>
                      <th className='fw-500'>Shaving Assistance</th>
                      <th className='fw-500'>Actions</th>
                    </tr>
                  </thead>
                )}
                <tbody>
                  {selectedAreas.length > 0 &&
                    selectedAreas.map((area) => (
                      <AreaRow
                        key={area.id}
                        area={area}
                        deleteArea={deleteArea}
                        setSelectedAreas={setSelectedAreas}
                      />
                    ))}
                </tbody>
              </Table>
            </Card.Body>
            {extensionsTimesTotal > 0 && (
              <Card.Footer className='text-center milan-bg-light-tur rounded-bottom'>
                <div className='text-start text-muted text-capitalize'>
                  <small className='fw-bold'>
                    Additional time included for:{' '}
                  </small>
                  <small>{formatExtensionMessage(extensionsTimes)}</small>
                </div>
              </Card.Footer>
            )}
          </Card>
          <div className='text-center mt-4 print-hide'>
            <button
              type='button'
              className='milan-btn milan-primary-btn clear-btn'
              onClick={clearAllAreas}
              disabled={selectedAreas.length === 0}
            >
              Clear All Areas
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TTOutputs;

//   // Use the spread operator to avoid altering the original array
//   const sortedSelectedAreas = [...selectedAreas].sort(
//    (a, b) => treatmentTimeMap[b.size] - treatmentTimeMap[a.size]
//  ); // First element will be the biggest time
//  // 1. Start with 10 minutes initially
//  // 2. Subtract 10 minutes from each area
//  // 3. Calculate the times
//  let minutes = sortedSelectedAreas.reduce(function (acc, area) {
//    return acc + (treatmentTimeMap[area.size] - 10);
//  }, 10);
//  // Up until now, the calculation would be correct for all body sizes except for XS areas
//  // The above reduce func makes each XS area time = 0 minutes, which is incorrect when adding 2 or more XS areas. Therefore,
//  // 4. 10 minutes should be added for each XS areas (Except the first XS area) when 2 or more XS areas are selected
//  // Get the count of all XS areas if any
//  const XS_Areas = sortedSelectedAreas.filter((area) => area.size === 'XS');
//  const XS_AreasCount = XS_Areas.length;
//  // Note: When ALL the selected areas are XS (condition2 below), the calculation is a bit different
//  /**
//   * condition1 is false -> expression3
//   * condition1 & condition2 are true -> expression1
//   * condition1 is true but condition2 is false -> expression2
//   */
//  minutes +=
//    XS_AreasCount >= 2
//      ? XS_AreasCount === sortedSelectedAreas.length
//        ? 10 * (XS_AreasCount - 1) - 10
//        : 10 * (XS_AreasCount - 1)
//      : 0;

//  // ***** UNIQUE SITUATION ***** //
//  // Full Face & Neck is a combination of 7 smaller areas ['unibrow', 'upper_lip', 'chin', 'cheeks', 'neck', 'sideburns', 'jawline']
//  // Full Face & Neck tx time is 20 minutes. However, each of its children time is 10 minutes
//  // When selecting 3 or more of its children, the sum will exceed their parent's time and that doesn't make sense. Therefore,
//  if (XS_AreasCount > 2) {
//    const FFN = combinable.find(
//      (elem) => elem.parentId === 'full_face_and_neck'
//    );
//    const ffnAreas = XS_Areas.filter((area) =>
//      FFN.childrenIds.includes(area.id)
//    );
//    if (ffnAreas.length > 2) {
//      // If ALL the selected areas are children of Full Face & Neck
//      if (ffnAreas.length === selectedAreas.length) minutes = 20;
//      else minutes -= 10 * (ffnAreas.length - 2);
//    }
//  }

//  // ***** FINALLY: Minutes cannot exceed 120 ***** //
//  if (minutes > 120) minutes = 120;
